export const AvailableViews = ['list', 'table', 'grid'] as const
export type ProductView = (typeof AvailableViews)[number]

export interface ProductFieldReturn {
  printValue?: string | number
  css?: string
  label?: string
}
